export const DATE_PICKER_POPPER_WIDTH = '504px'
